import axios from 'axios';
import authHeader from './auth-header';
const API_URL = process.env.REACT_APP_API_ROOT+ '/api/product/';

class ProductService {
  findAll() {
    return axios.post(API_URL + 'findall',{},{ headers: authHeader(true) });
  }

  fetchAll() {
    return axios.post(API_URL + 'fetchall', {},{ headers: authHeader(true) });
  }
  fetchById(partNumber?:string,style?:string,shouldFetch?:boolean) {
    console.log('[fetchById]');
    
    let data = {"partnumber":"","style":"","shouldfetch":false};
    if(partNumber){
      data["partnumber"] = partNumber;
    }
    if(style){
      data["style"] = style;
    }
    if(!!shouldFetch){
      data["shouldfetch"] = true;
    }
    console.log(data);
    return axios.post(API_URL + 'fetchById',data, { headers: authHeader(true) });
  }
  clear() {
    return axios.post(API_URL + 'clear',{},{ headers: authHeader(true) });
  }
}

export default new ProductService();
